const appendParam = (params, key, value) => {
  if (!value) {
    return;
  }

  params.push(`${key}=${encodeURIComponent(value)}`);
};

export const buildAcquisitionUrl = (path, acquisitionData = {}) => {
  const {
    acquisitionRef,
    fbclid,
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
    utmAdset,
    utmTerm,
    trialOffer,
  } = acquisitionData;

  const params = [];
  appendParam(params, "ref", acquisitionRef);
  appendParam(params, "fbclid", fbclid);
  appendParam(params, "utm_source", utmSource);
  appendParam(params, "utm_medium", utmMedium);
  appendParam(params, "utm_campaign", utmCampaign);
  appendParam(params, "utm_content", utmContent);
  appendParam(params, "utm_adset", utmAdset);
  appendParam(params, "utm_term", utmTerm);
  appendParam(params, "trial_offer", trialOffer);

  if (params.length === 0) {
    return path;
  }

  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${params.join("&")}`;
};
